import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import ErrorMsg from './ErrorMsg';
import { _get } from 'core/utils/object-prop';

function FormField(props: {
  label?: string;
  children: React.ReactNode;
  hasAddon?: boolean;
  checkbox?: boolean;
  className?: string;
  field?: string;
  errors?: Record<string, string>;
  control: boolean;
  controlClass?: string;
  onClick?: (e: React.SyntheticEvent) => void;
  successMsg?: string;
  style?: CSSProperties;
}) {
  const {
    label,
    onClick,
    hasAddon,
    field,
    control,
    className,
    errors,
    controlClass,
    children,
    successMsg,
    style,
  } = props;

  const hasError = errors && field ? _get(errors, field) : false;
  return (
    <div
      onClick={onClick}
      className={classNames('field', className, hasError && 'has-error')}
      style={style}
    >
      {label ? <label className="label">{label}</label> : null}
      <div
        className={classNames(
          hasAddon && 'field has-addons',
          !hasAddon && control && 'control',
          controlClass,
        )}
      >
        {children}
      </div>
      {errors && field && hasError ? (
        <ErrorMsg field={field} errors={errors} />
      ) : null}

      {successMsg && !hasError && (
        <span className="help is-success">{successMsg}</span>
      )}
    </div>
  );
}

FormField.defaultProps = {
  control: true,
  className: '',
  controlClass: '',
};

export default FormField;
